import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { DatosConfiguracionAplicacionService } from '../services/datos-configuracion-aplicacion.service';
import { DatosEnviosService } from '../../Envios/envios/services/datos-envios.service';
import { ValidacionesFormularioRltService } from '../services/validaciones-formulario-rlt.service';
import { MatDialog } from '@angular/material/dialog';
import { DiaSemana } from '../models/configuracion-rlt';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-parametros-rlt',
  templateUrl: './parametros-rlt.component.html',
  styleUrls: ['./parametros-rlt.component.css']
})
export class ParametrosRltComponent implements OnInit {

  frecuencia:string[] = ['Diaria', 'Semanal', 'Quincenal', 'Mensual'];
  diasSemana: DiaSemana[] = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  @Input() tipoRlt: string = '';
  form: FormGroup;
  infoRlt: string = '';

  constructor(public datosConfiguracionAplicacionService: DatosConfiguracionAplicacionService,
              public validacionesFormularioRltService: ValidacionesFormularioRltService) {
               }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['tipoRlt'].currentValue) {
          this.infoRlt = this.tipoRlt === 'firmados' ? 'Enviar copia básica de los contratos firmados' : 'Enviar copia básica de los contratos  pendientes de firma';
    }
  }

  ngOnInit(): void {
    this.form = this.datosConfiguracionAplicacionService.getFormByTipo(this.tipoRlt);
  }

  get activo() { return this.form.controls['activo']; }
  get periodicidad() { return this.form.controls['periodicidad']; }
  get cadaDia() { return this.form.controls['cadaDia']; }
  get horaEnvio() { return this.form.controls['horaEnvio']; }
  get diaEnvio() { return this.form.controls['diaEnvio']; }
  get diaMes() { return this.form.controls['diaMes']; }
  get primerUltimoDia() { return this.form.controls['primerUltimoDia']; }
  get tipoDia() { return this.form.controls['tipoDia']; }
  get frecuenciaMensual() { return this.form.controls['frecuenciaMensual']; }
  get diasRetraso() { return this.form.controls['diasRetraso']; }
}

